<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="6">
      <v-card class="home pa-5" outlined>
        <v-card-title>
          <h1>Login</h1>
        </v-card-title>
        <v-card-text class="customer-login-form">
          <v-alert
            v-if="$route.query.codeVerified"
            type="success"
            dense
            text
            class="pa-2 my-2"
            >Your phone number has been verified.</v-alert
          >
          <LoginEmailPassForm />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import LoginEmailPassForm from '@/components/LoginEmailPassForm'
export default {
  name: 'LoginEmailView',
  components: {
    LoginEmailPassForm,
  },
  data: () => {
    return {}
  },
}
</script>

<style lang="css">
.customer-login-form input {
  font-size: 2em;
  line-height: 1.3 !important;
  max-height: none !important;
}
</style>
